import { render } from "./AccessModule.vue?vue&type=template&id=4ffac18a"
import script from "./AccessModule.vue?vue&type=script&lang=js"
export * from "./AccessModule.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__